export function toTitleCase(str = '') {
  return str.replace(/_/g, ' ').replace(/\w\S*/g, function (txt: string) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}
